<script setup lang="ts">
import AutocompleteField from '@/components/Selector/AutocompleteField.vue'
import type { SelectorObject } from '@/types/components/SelectorObject'
import { computed, ref } from 'vue'

type Props = {
    races?: string[]
    raceFilter?: string
}
const props = defineProps<Props>()
type Emits = {
    (e: 'changeRaceFilter', value?: string): void
}
const emit = defineEmits<Emits>()

const racesOptions = computed(() => props.races?.map(value => ({ name: value, value })))
const raceInput = ref<string>()
const handleRaceTyping = (value: string) => (raceInput.value = value)
const handleSelect = (value: SelectorObject) => {
    raceInput.value = undefined
    emit('changeRaceFilter', value?.value as string)
}

const filteredRaceWithInput = computed(() =>
    raceInput.value
        ? racesOptions.value?.filter(item => item.value.match(new RegExp(raceInput.value!, 'gi')))
        : racesOptions.value
)
</script>

<template>
    <AutocompleteField
        :label="$t('event.detail.checkpoints.race')"
        :options="filteredRaceWithInput"
        :modelValue="racesOptions?.find(item => item.value === raceFilter)?.value"
        @typing="handleRaceTyping"
        @select="handleSelect"
        clearable />
</template>
